import log from 'sentry/log'
import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api/actions'
import { actionCreators as account } from 'reduxBits/account/actions'

const prefix = 'Newsletter opt-out:'
export const REQUEST_EMAIL = `${prefix} Request email`
export const RECEIVE_EMAIL = `${prefix} Receive email`
export const REQUEST_OPT_OUT = `${prefix} Request opt-out`
export const RECEIVE_OPT_OUT = `${prefix} Receive opt-out`

const requestEmail = createAction(REQUEST_EMAIL)
const receiveEmail = createAction(RECEIVE_EMAIL)
const requestOptOut = createAction(REQUEST_OPT_OUT)
const receiveOptOut = createAction(RECEIVE_OPT_OUT)

/*
 * Get the email of a logged in or non-logged in user
 * by their subscription id
 */
export const getEmail = (subscriptionId) => (dispatch) => {
  dispatch(requestEmail())

  const url = `auth/v1/subscriptions/${subscriptionId}`
  dispatch(api.fetch(url)).then(
    (data) => {
      dispatch(receiveEmail(data.email))
    },
    (error) => {
      log.error(error)
      dispatch(receiveEmail(error))
    },
  )
}

/*
 * Unregister from future newsletters by setting
 * the accept_newsletter flag on the account
 * and authenticating via the subscription id
 */
export const optOut = (subscriptionId) => (dispatch) => {
  dispatch(requestOptOut())

  const url = `auth/v1/subscriptions/${subscriptionId}`
  const opts = {
    method: 'PUT',
    body: JSON.stringify({ accept_newsletter: false }),
  }
  dispatch(api.fetch(url, opts)).then(
    () => {
      dispatch(account.fetchUserInformation(true)) // refresh the account information
      dispatch(receiveOptOut())
    },
    (error) => {
      log.error(error)
      dispatch(receiveOptOut(error))
    },
  )
}

export const actionCreators = {
  requestEmail,
  receiveEmail,
  requestOptOut,
  receiveOptOut,
}
